import React from 'react';
import apiUrl from "../../enviroments/enviroment";
import axios from 'axios';

class CatRemitentes extends React.Component {

    state = {
        remitentes: [],
    };


    componentDidMount() {
        this.peticion();
    }

    peticion  = async () => {
        axios.get(`${apiUrl.apiUrl}remitentes_courier/` + localStorage.getItem('seccion'), {
            headers: {
                userid: 'transexpress',
                pwduser: 'JTOYV9IlFarK6G2jPRo7dJxkmfHOhD9S',
            }
        }).then(res => {
            this.setState({remitentes: res.data});
        });
        console.log(this.state.remitentes);
    }

    render(){
        return(
            this.state.remitentes.map((gen) => <option  key={gen.id_remitente} value={gen.id_remitente}>{gen.nombre}</option>)
        );
    }

}

export default CatRemitentes;
